import { motion } from 'motion/react'

export interface AnimatedMenuProps {
  index: number
  children: React.ReactNode
}

export function AnimatedMenu({ index, children }: AnimatedMenuProps) {
  return (
    <motion.div
      custom={index}
      initial='hidden'
      animate='visible'
      variants={{
        visible: i => ({
          opacity: 1,
          y: 0,
          transition: { ease: 'easeOut', delay: i * 0.1, duration: 0.25 },
        }),
        hidden: { opacity: 0, y: -20 },
      }}
    >
      {children}
    </motion.div>
  )
}
